import { api } from "@";
import { savePayload, searchValuesPayload } from "./helpers";

// Function to get messages with pagination and search filters
export const getMessages = (page = 1, pageSize = "", search) => {
  return api.post(
    `/api/AdminScheduledMessages/scheduled`,
    searchValuesPayload(page, pageSize, search),
  );
};

// Function to get message
export const getMessage = (id) => {
  if (!id) return;
  return api.get(`/api/AdminScheduledMessages/${id}`);
};

// Function to get projects
export const getProjects = () => {
  return api.get(`/api/AdminScheduledMessages/active-projects`);
};

export const getAllEnums = () =>
  api.get(`/api/AdminScheduledMessages/all-create-enums`);

// Function to save message
export const saveMessage = (data) => {
  if (data.id) {
    return api.put(`/api/AdminScheduledMessages/${data.id}`, savePayload(data));
  }
  return api.post(`/api/AdminScheduledMessages/schedule`, savePayload(data));
};
